import React from "react";

var PriceStateContext = React.createContext();
var PriceDispatchContext = React.createContext();

function PriceReducer(state, action) {
  switch (action.type) {
    case "ADDPRICE":
      return {...state, Price:state.Price+action.payload};
    case "REMOVEPRICE":
      return {...state, Price:state.Price-action.payload};
    
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function PriceProvider({children}) {
  var [state, dispatch] = React.useReducer(PriceReducer, {
    Price: 0,
  });
  return (
    <PriceStateContext.Provider value={state}>
      <PriceDispatchContext.Provider value={dispatch}>
        {children}
      </PriceDispatchContext.Provider>
    </PriceStateContext.Provider>
  );
}

function usePriceState() {
  var context = React.useContext(PriceStateContext);
  if (context === undefined) {
    throw new Error("useLayoutState must be used within a LayoutProvider");
  }
  return context;
}

function usePriceDispatch() {
  var context = React.useContext(PriceDispatchContext);
  if (context === undefined) {
    throw new Error("useLayoutDispatch must be used within a LayoutProvider");
  }
  return context;
}

export {PriceProvider, usePriceState, usePriceDispatch, AddPrice,RemovePrice};

// ###########################################################
function AddPrice(dispatch,value) {
  dispatch({
    type: "ADDPRICE",
    payload:value
  });
}
function RemovePrice(dispatch,value) {
  dispatch({
    type: "REMOVEPRICE",
    payload:value
  });
}
